import { EventBroker } from "@/frontend/lib/utils/event-broker";

export const IMAGE_SEGMENTATION_EVENTS = {
    // Triggered when the preview modal should be shown
    SHOW_PREVIEW: 'SHOW_PREVIEW',
    // Triggered when the preview modal should be shown with cached data (no re-parsing needed)
    SHOW_CACHED_PREVIEW: 'SHOW_CACHED_PREVIEW',
    // Triggered when segmentation job completes (from WebSocket)
    JOB_COMPLETED: 'JOB_COMPLETED',
    // Triggered when segmentation job fails
    JOB_FAILED: 'JOB_FAILED',
    // Triggered when user confirms layer selection
    LAYERS_CONFIRMED: 'LAYERS_CONFIRMED',
    // Triggered when AI Studio confirms layers without creating a layout
    AI_STUDIO_LAYERS_CONFIRMED: 'AI_STUDIO_LAYERS_CONFIRMED',
    // Triggered when AI Studio explicitly requests downloading the selected layers
    AI_STUDIO_LAYERS_DOWNLOAD_REQUESTED: 'AI_STUDIO_LAYERS_DOWNLOAD_REQUESTED',
    // Triggered when AI Studio asks to save the selected layers to a File Browser folder
    AI_STUDIO_LAYERS_SAVE_REQUESTED: 'AI_STUDIO_LAYERS_SAVE_REQUESTED',
    // Triggered when the modal is closed
    CLOSED: 'CLOSED',
    // Triggered when a multi-image queue could not build its layout
    QUEUE_FAILED: 'QUEUE_FAILED',
};

export const imageSegmentationEventBroker = new EventBroker();
